import React, { useEffect, useState } from "react";
import "./Div.css";
import star from "../../Asists/img/06.png";
import file from "../../Asists/img/domain.png";
import foto_absalute from "../../Asists/img/foto.png";
import fintech from "../../Asists/img/fintechhub.svg";
import { GraduationCap, LocationDot, Telegram } from "../Icons/Icons";
import { navigate } from "../../router";

const RAQAM_UZUNLIGI = 9; // +998 dan keyingi raqamlar soni

// Faqat raqamlarni qoldiradi va 9 tadan oshirmaydi
const raqamlar = (qiymat) =>
  (qiymat || "").replace(/\D/g, "").slice(0, RAQAM_UZUNLIGI);

// 901234567 -> "90 123 45 67"
const koFormat = (d) =>
  [d.slice(0, 2), d.slice(2, 5), d.slice(5, 7), d.slice(7, 9)]
    .filter(Boolean)
    .join(" ");

// Serverdagi tekshiruv bilan bir xil qoida: 9 ta raqam, kamida 3 xil raqam
const telXatosi = (d, majburiy) => {
  if (!d) return majburiy ? "Telefon raqamingizni kiriting." : "";
  if (d.length < RAQAM_UZUNLIGI)
    return `Raqam to'liq emas — 9 ta raqam kerak, hozir ${d.length} ta.`;
  if (new Set(d).size <= 2)
    return "Bunday raqam mavjud emas. Haqiqiy raqamingizni kiriting.";
  return "";
};


const ismXatosi = (qiymat) => {
  const t = (qiymat || "").trim();
  if (!t) return "Ismingizni kiriting.";
  if (t.length < 2) return "Ism juda qisqa.";
  return "";
};

// POST JSON. Xato shakli `serverXatolari` kutganidek: server javob bersa
// `err.response.data` bo'ladi, tarmoq uzilsa — bo'lmaydi.
const yubor = async (url, body) => {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (res.ok) return;
  let data;
  try {
    data = await res.json();
  } catch {
    data = await res.text().catch(() => "");
  }
  const err = new Error(`HTTP ${res.status}`);
  err.response = { status: res.status, data };
  throw err;
};

// Meta cookie'lari — backend'dagi Conversions API (AmoCRM "Ma'lumot berildi")
// lidni reklama kliki bilan bog'lashi uchun. Yo'q bo'lsa yuborilmaydi.
// _fbc cookie hali qo'yilmagan bo'lsa, URL'dagi fbclid'dan Meta formatida yasaladi.
const cookie = (name) =>
  document.cookie
    .split("; ")
    .find((c) => c.startsWith(name + "="))
    ?.slice(name.length + 1) || "";

const metaCookies = () => {
  const out = {};
  const fbp = cookie("_fbp");
  let fbc = cookie("_fbc");
  if (!fbc) {
    const fbclid = new URLSearchParams(window.location.search).get("fbclid");
    if (fbclid) fbc = `fb.1.${Date.now()}.${fbclid}`;
  }
  if (fbp) out.fbp = fbp;
  if (fbc) out.fbc = fbc;
  return out;
};

// DRF {maydon: [xabar]} javobini maydonlar bo'yicha taqsimlaydi
const serverXatolari = (err) => {
  const data = err?.response?.data;
  if (!data)
    return { umumiy: "Aloqa uzildi. Internetni tekshirib, qaytadan urining." };
  if (typeof data === "string") return { umumiy: data };

  const natija = {};
  Object.entries(data).forEach(([maydon, xabar]) => {
    const matn = Array.isArray(xabar) ? xabar.join(" ") : String(xabar);
    if (maydon === "ism" || maydon === "phone") {
      natija[maydon] = matn;
    } else {
      natija.umumiy = natija.umumiy ? `${natija.umumiy} ${matn}` : matn;
    }
  });
  if (!Object.keys(natija).length)
    natija.umumiy = "Ma'lumotlarni tekshirib, qaytadan yuboring.";
  return natija;
};

const XatoIkonka = () => (
  <svg
    className="ff-error-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
  </svg>
);

export default function Div() {
  const [num, setNum] = useState("");
  const [name, setName] = useState("");
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [utmSource, setUtmSource] = useState("default");
  const [utmContent, setUtmContent] = useState("default");
  const [utmMedium, setUtmMedium] = useState("default");
  const [utmId, setUtmId] = useState("default");
  const [region, setRegion] = useState("Toshkent shahri");
  const utm_src_url = `source:${utmSource} content:${utmContent} id:${utmId} medium:${utmMedium}`;

  useEffect(() => {
    // URL'dan UTM source ni olish
    const searchParams = new URLSearchParams(window.location.search);
    const source = searchParams.get("utm_source") || "default";
    const content = searchParams.get("utm_content") || "default";
    const medium = searchParams.get("utm_medium") || "default";
    const id = searchParams.get("utm_id") || "default";
    setUtmSource(source);
    setUtmContent(content);
    setUtmMedium(medium);
    setUtmId(id);
  }, []);

  const xatoniTozala = (maydon) =>
    setErrors((oldingi) => ({ ...oldingi, [maydon]: "", umumiy: "" }));

  const handleregister = async (e) => {
    e.preventDefault();
    if (sending) return; // ikki marta bosilsa dublikat lead yaratilmasin

    const d1 = raqamlar(num);

    const yangi = {
      ism: ismXatosi(name),
      phone: telXatosi(d1, true),
    };

    setErrors(yangi);
    if (yangi.ism || yangi.phone) return;

    const data = {
      familiya: utm_src_url,
      ism: name.trim(),
      kurs: "frontend",
      phone: `998${d1}`,
      target: 4,
      desc: `${window.location.search} region:${region}`,
      ...metaCookies(),
    };

    setSending(true);
    try {
      await yubor("https://form-api.fintechhub.uz/api/register/", data);
      setName("");
      setNum("");
      setErrors({});
      navigate("/thankyou");
    } catch (err) {
      setErrors(serverXatolari(err));
    } finally {
      setSending(false);
    }
  };

  const maydonXatolari = ["ism", "phone"].filter(
    (k) => errors[k]
  ).length;
  const bannerMatni =
    errors.umumiy ||
    (maydonXatolari > 1
      ? `Quyidagi ${maydonXatolari} ta maydonni tekshiring.`
      : "");

  return (
    <div>
      <div className="boss">
        <div className="first">
          <img className="fintech" src={fintech} alt="" />
          <div className="box-top-left">
            <GraduationCap className="fa-solid fa-graduation-cap" />
            <h1 className="text-top-left">
              Dasturlashni <br />
              o'rganmoqchimisiz?
            </h1>
          </div>
          <div className="center-left">
            <h1 className="center-text">Unda bizni eshiting:</h1>
            <div className="list">
              <p className="left-text">
                <img src={star} alt="" />
                Senior darajadagi ustozlar
              </p>
              <p className="left-text">
                <img src={star} alt="" />
                Amaliy ko'nikmalar
              </p>
              <p className="left-text">
                <img src={star} alt="" />
                Pullik Real loyihalarda tajriba to'plash
              </p>
              <p className="left-text">
                <img src={star} alt="" />
                Startup loyihangizga investitsiya kiritish imkoniyati
              </p>
              <p className="left-text">
                <img src={star} alt="" />
                Zamonaviy dasturlash atmosferasi
              </p>
            </div>
          </div>
          <div className="left-bottom">
            <img src={file} alt="" />
            <p className="bottom-p">
              Professional dasturchi bo'lmoqchi bo'lsangiz hoziroq
              <br /> ro‘yxatdan o‘ting!
            </p>
          </div>
        </div>
        <div className="box">
          <p className="location">
            <LocationDot className="fa-solid fa-location-dot" />
            Toshkent
          </p>
          <div className="second">
            <h1 className="right-top">
              Dasturlashga ilk qadam <br />
              <span>FinTechHub</span>
              dan boshlanadi!
            </h1>
            <p className="right">
              Sinov darsiga yozilish uchun ro'yxatdan o'ting
            </p>

            <form onSubmit={handleregister} noValidate>
              {bannerMatni && (
                <div
                  className={`ff-banner${errors.umumiy ? "" : " ff-banner--soni"}`}
                  role="alert"
                >
                  <XatoIkonka />
                  <span>
                    <strong>Ariza yuborilmadi.</strong> {bannerMatni}
                  </span>
                </div>
              )}

              <div className="ff-field">
                <label className="ff-label" htmlFor="ff-ism">
                  Ismingiz <span className="ff-req">*</span>
                </label>
                <input
                  id="ff-ism"
                  className={`ff-input${errors.ism ? " is-error" : ""}`}
                  type="text"
                  autoComplete="name"
                  placeholder="Masalan, Asadbek"
                  value={name}
                  aria-invalid={errors.ism ? "true" : "false"}
                  aria-describedby={errors.ism ? "ff-ism-xato" : undefined}
                  onChange={(e) => {
                    setName(e.target.value);
                    xatoniTozala("ism");
                  }}
                  onBlur={() =>
                    setErrors((o) => ({ ...o, ism: ismXatosi(name) }))
                  }
                />
                {errors.ism && (
                  <p className="ff-error" id="ff-ism-xato">
                    <XatoIkonka />
                    {errors.ism}
                  </p>
                )}
              </div>

              <div className="ff-field">
                <label className="ff-label" htmlFor="ff-tel">
                  Telefon raqamingiz <span className="ff-req">*</span>
                </label>
                <div className={`ff-tel${errors.phone ? " is-error" : ""}`}>
                  <span className="ff-tel-prefix">+998</span>
                  <input
                    id="ff-tel"
                    type="tel"
                    inputMode="numeric"
                    autoComplete="tel"
                    maxLength={12}
                    placeholder="90 123 45 67"
                    value={koFormat(raqamlar(num))}
                    aria-invalid={errors.phone ? "true" : "false"}
                    aria-describedby={errors.phone ? "ff-tel-xato" : undefined}
                    onChange={(e) => {
                      setNum(raqamlar(e.target.value));
                      xatoniTozala("phone");
                    }}
                    onBlur={() =>
                      setErrors((o) => ({
                        ...o,
                        phone: telXatosi(raqamlar(num), true),
                      }))
                    }
                  />
                </div>
                {errors.phone && (
                  <p className="ff-error" id="ff-tel-xato">
                    <XatoIkonka />
                    {errors.phone}
                  </p>
                )}
              </div>


              <div className="ff-field">
                <label className="ff-label" htmlFor="ff-viloyat">
                  Viloyatingiz <span className="ff-req">*</span>
                </label>
                <div className="ff-select-wrap">
                  <select
                    id="ff-viloyat"
                    className="ff-select"
                    onChange={(e) => setRegion(e.target.value)}
                    value={region}
                  >
                    <option value="Toshkent shahri">Toshkent shahri</option>
                    <option value="Toshkent viloyati">Toshkent viloyati</option>
                    <option value="Andijon viloyati">Andijon viloyati</option>
                    <option value="Buxoro viloyati">Buxoro viloyati</option>
                    <option value="Farg'ona viloyati">Farg'ona viloyati</option>
                    <option value="Jizzax viloyati">Jizzax viloyati</option>
                    <option value="Xorazm viloyati">Xorazm viloyati</option>
                    <option value="Namangan viloyati">Namangan viloyati</option>
                    <option value="Navoiy viloyati">Navoiy viloyati</option>
                    <option value="Qashqadaryo viloyati">
                      Qashqadaryo viloyati
                    </option>
                    <option value="Qoraqalpog'iston Respublikasi">
                      Qoraqalpog'iston Respublikasi
                    </option>
                    <option value="Samarqand viloyati">
                      Samarqand viloyati
                    </option>
                    <option value="Sirdaryo viloyati">Sirdaryo viloyati</option>
                    <option value="Surxondaryo viloyati">
                      Surxondaryo viloyati
                    </option>
                  </select>
                  <svg
                    className="ff-select-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </div>
              </div>

              <button type="submit" disabled={sending}>
                {sending ? "Yuborilmoqda..." : "Sinov darsiga yozilish"}
              </button>

              <a className="teleg" href="https://t.me/fintech_qabull">
                <Telegram className="fa-brands fa-telegram" />Telegram orqali
                bog'lanish
              </a>

              <p className="ff-maxfiy">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                Ma'lumotlaringiz uchinchi shaxsga berilmaydi
              </p>
            </form>

            <div className="right-bottom">
              <p className="one">!</p>
              <p className="two">
                Hozirda o'quv markazimiz faqat Toshkent shahrida joylashgan
              </p>
            </div>
          </div>
        </div>
        <div className="foto">
          <img src={foto_absalute} alt="" loading="lazy" />
        </div>
      </div>
    </div>
  );
}
